export const baseConversionRates = {
	/**
	 * 1 NOK = 0.1 EUR
	 */
	EUR: 0.1,
	/**
	 * 1 NOK = 0.65 DKK
	 */
	DKK: 0.65,

	/**
	 * 1 NOK = 1 SEK
	 */
	SEK: 1,
	NOK: 1,
};

export type Currency = keyof typeof baseConversionRates;

/**
 * 1 point is worth 0.05 NOK.
 * 1000 points = 50 NOK
 * 2000 points = 100 NOK
 */
export const POINTS_RATE = 0.05;

/**
 * Bonus value unlocked per 1,000-point tier, as configured in Yotpo per market.
 * These are not derived from baseConversionRates — each market has its own Yotpo setup.
 */
export const BONUS_PER_TIER: Record<Currency, number> = {
	NOK: 50,
	SEK: 50,
	DKK: 50,
	EUR: 5,
};

export const pointsToCurrency = (
	points: number,
	currency: keyof typeof baseConversionRates = "NOK",
): number => {
	const nokValue = points * POINTS_RATE;
	return convertNokTo(currency, nokValue);
};

export const convertPointsTo = (to: keyof typeof baseConversionRates, points: number): number => {
	return pointsToCurrency(points, to);
};

/**
 * Converts an amount in NOK to the specified currency using the base conversion rates.
 */
export const convertNokTo = (to: keyof typeof baseConversionRates, amount: number): number => {
	const CR = baseConversionRates[to];
	if (CR === undefined) {
		console.warn("Conversion rate not found for", to);
		return amount;
	}
	return amount * baseConversionRates[to];
};

export const convertCurrencyToNok = (
	from: keyof typeof baseConversionRates,
	amount: number,
): number => {
	const CR = baseConversionRates[from];
	if (CR === undefined) {
		console.warn("Conversion rate not found for", from);
		return amount;
	}
	return amount / CR;
};

export const currencyToPoints = (
	_currency: keyof typeof baseConversionRates,
	amount: number,
	pointsPerUnit: number,
): number => {
	return Math.floor(amount * pointsPerUnit);
};
